var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 32C25.5035 32 32.667 24.8366 32.667 16.0001C32.667 7.16354 25.5035 0.00012207 16.667 0.00012207C7.83043 0.00012207 0.666992 7.16354 0.666992 16.0001C0.666992 24.8366 7.83043 32 16.667 32ZM24.0812 13.4143C24.8622 12.6332 24.8622 11.3669 24.0812 10.5859C23.3001 9.80483 22.0338 9.80483 21.2528 10.5859L14.667 17.1716L12.0812 14.5859C11.3002 13.8048 10.0338 13.8048 9.25278 14.5859C8.47173 15.3669 8.47173 16.6332 9.25278 17.4143L13.2528 21.4143C14.0338 22.1953 15.3002 22.1953 16.0812 21.4143L24.0812 13.4143Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished);
export default __webpack_public_path__ + "static/media/finished.4400afdb7fbfcff713e3322d2315e9d2.svg";
export { ForwardRef as ReactComponent };